import { actionCreators as userActionCreators } from "./userActions";

/* TYPES */
const TOGGLE_MOBILE_QR_SETTINGS = "TOGGLE_MOBILE_QR_SETTINGS";

const TOGGLE_DEVICE_SETTINGS = "TOGGLE_DEVICE_SETTINGS";
const SWITCH_TO_TAB = "SWITCH_TO_TAB";
const HIDE_DEVICE_SETTINGS = "HIDE_DEVICE_SETTINGS";

const TOGGLE_WIDGET_SETTINGS = "TOGGLE_WIDGET_SETTINGS";

const START_DRAG = "START DRAG";
const CANCEL_DRAG = "CANCEL_DRAG";

const TOGGLE_UIMODE = "TOGGLE_UIMODE";
const SET_UIMODE = "SET_UIMODE";
const SET_PRESENTATION_VIEW_MODE = "SET_PRESENTATION_VIEW_MODE";

const SET_HOVERED_WIDGET = "SET_HOVERED_WIDGET";
const SET_HOVERED_SENSOR = "SET_HOVERED_SENSOR";

const SET_DETECTED_QUERX = "SET_DETECTED_QUERX";
const RESET_DETECTED_QUERX = "RESET_DETECTED_QUERX";

const ADD_TO_DEVICE_TEMPLATE_BLACKLIST = "ADD_TO_DEVICE_TEMPLATE_BLACKLIST";
const REMOVE_FROM_DEVICE_TEMPLATE_BLACKLIST =
  "REMOVE_FROM_DEVICE_TEMPLATE_BLACKLIST";


/* ACTION CREATORS */

const toggleMobileQrSettings = () => {
  return {
    type: TOGGLE_MOBILE_QR_SETTINGS
  }
}

const toggleDeviceSettings = (uid, sensorKey) => {
  return {
    type: TOGGLE_DEVICE_SETTINGS,
    uid,
    sensorKey
  };
};

const switchToTab = (device_uid, sensorKey) => {
  console.log("switchToTab action creator called", sensorKey);
  return {
    type: SWITCH_TO_TAB,
    uid: device_uid,
    sensorKey
  };
};

const hideDeviceSettings = (uid, sensorKey) => {
  console.log("hidedevicesettings");
  return {
    type: HIDE_DEVICE_SETTINGS,
    uid,
    sensorKey
  };
};

const toggleWidgetSettings = widgetid => {
  return {
    type: TOGGLE_WIDGET_SETTINGS,
    widgetid
  };
};

/* DRAGGING */

const startDrag = (originx, originy, source) => {
  console.log("startdrag action creator");
  return {
    type: START_DRAG,
    originx,
    originy,
    source
  };
};

const cancelDrag = () => {
  console.log("startdrag action creator");
  return {
    type: CANCEL_DRAG
  };
};

/* UI MODE */
const toggleUIMode = () => {
  //console.log("toggleUIMode Action creator")
  return dispatch => {
    dispatch({
      type: TOGGLE_UIMODE
    });
    dispatch(userActionCreators.persistUIConfig());
  };
};

const setUIMode = (mode, persist) => {
  return dispatch => {
    dispatch({
      type: SET_UIMODE,
      mode
    });
    persist && dispatch(userActionCreators.persistUIConfig());
  };
};

/* PRESENTATION_VIEW_MODE */
const setPresentationViewMode = mode => {
  //console.log("setPresentationViewMode action creator called. Mode:", mode)
  return dispatch => {
    dispatch({
      type: SET_PRESENTATION_VIEW_MODE,
      mode
    });
    dispatch(userActionCreators.persistUIConfig());
  };
};

/* HOVERED WIDGET,... for wire display */
const setHoveredWidget = widgetid => {
  return {
    type: SET_HOVERED_WIDGET,
    widgetid
  };
};

/* HOVERED WIDGET,... for wire display */
const setHoveredSensor = (deviceid, sensorid) => {
  return {
    type: SET_HOVERED_SENSOR,
    deviceid,
    sensorid
  };
};

/* QUERX DETECTED ... for showing the popup promt for querx auto config with Palamoa templates */
// TODO: arguments like querx type
const setDetectedQuerx = (qname, template_val, device_id) => {
  console.log(
    "setDetectedQuerx action creator called",
    qname,
    template_val,
    device_id
  );
  return {
    type: SET_DETECTED_QUERX,
    qname,
    template_val,
    device_id
  };
};

const resetDetectedQuerx = () => {
  return {
    type: RESET_DETECTED_QUERX
  };
};

// TODO: move to uiConmfig actions!
const addToDeviceTemplateBlacklist = (device_uid, template_val) => {
  console.log("addToDeviceTemplateBlacklist action creator called");

  return dispatch => {
    dispatch({
      type: ADD_TO_DEVICE_TEMPLATE_BLACKLIST,
      device_uid,
      template_val
    });
    dispatch(userActionCreators.persistUIConfig());
  };
};

const removeFromDeviceTemplateBlacklist = device_uid => {
  console.log("removeFromDeviceTemplateBlacklist action creator called");
  return dispatch => {
    dispatch({
      type: REMOVE_FROM_DEVICE_TEMPLATE_BLACKLIST,
      device_uid
    });
    dispatch(userActionCreators.persistUIConfig());
  };
};

/* EXPORTS */
export const actionsTypes = {
  TOGGLE_MOBILE_QR_SETTINGS,
  TOGGLE_DEVICE_SETTINGS,
  HIDE_DEVICE_SETTINGS,
  SWITCH_TO_TAB,
  TOGGLE_WIDGET_SETTINGS,
  START_DRAG,
  CANCEL_DRAG,
  TOGGLE_UIMODE,
  SET_UIMODE,
  SET_PRESENTATION_VIEW_MODE,
  SET_HOVERED_WIDGET,
  SET_HOVERED_SENSOR,
  SET_DETECTED_QUERX,
  RESET_DETECTED_QUERX,
  ADD_TO_DEVICE_TEMPLATE_BLACKLIST,
  REMOVE_FROM_DEVICE_TEMPLATE_BLACKLIST
};
export const actionCreators = {
  toggleMobileQrSettings,
  toggleDeviceSettings,
  hideDeviceSettings,
  toggleWidgetSettings,
  switchToTab,
  startDrag,
  cancelDrag,
  toggleUIMode,
  setUIMode,
  setPresentationViewMode,
  setHoveredWidget,
  setHoveredSensor,
  setDetectedQuerx,
  resetDetectedQuerx,
  addToDeviceTemplateBlacklist,
  removeFromDeviceTemplateBlacklist
};
